import { AuthGuard } from './auth/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssignTaskComponent } from './all-modules/projects-management/assigntask/assign-task/assign-task.component';

const routes: Routes = [
  { path: 'login', loadChildren: () => import(`./login/login.module`).then(m => m.LoginModule) },
  
  { path: 'error', loadChildren: () => import(`./errorpages/errorpages.module`).then(m => m.ErrorpagesModule) },

  {
    path: '',
    loadChildren: () => import(`./all-modules/all-modules.module`).then(m => m.AllModulesModule),
    canActivate: [AuthGuard]
  },
  { path: 'manage-users', loadChildren: () => import('./all-modules/manage-users/manage-users.module').then(m => m.ManageUsersModule) },
  { path: 'manage-equipment', loadChildren: () => import('./all-modules/manage-equipment/manage-equipment.module').then(m => m.ManageEquipmentModule) },
  { path: 'manage-enquiry', loadChildren: () => import('./all-modules/manage-enquiry/manage-enquiry.module').then(m => m.ManageEnquiryModule) },
  { path: 'assign-equipment', loadChildren: () => import('./all-modules/assign-equipment/assign-equipment.module').then(m => m.AssignEquipmentModule) },
  
  
  // { path: '**', loadChildren: () => import(`./login/login.module`).then(m => m.LoginModule) },
  { path: '**', loadChildren: () => import(`./errorpages/errorpages.module`).then(m => m.ErrorpagesModule) },

  

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', useHash: false, })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
